/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class VolumeTransferService {
	private volTransferDataUrl: string = environment.host + '/volumeTransfers';
	private volTransferUrl: string = environment.host + '/volumeTransfer';
	private volTransferPlanUrl: string = environment.host + '/volumeTransfer';
	private allVolumeDefinitions = environment.host + '/volume-definitions';

	constructor(private http: HttpClient) { }

	public getVolumeCalculation(payload: any){
		const url = environment.host+'/volumeCalculation';
		return this.http.post(url, payload).toPromise();
	}

	public getAllVolumeTransferDetails() {
		return this.http.get(this.volTransferDataUrl.toString()).toPromise();
	}

	public getAllVolumeDefinitions(){
		return this.http.get(this.allVolumeDefinitions.toString()).toPromise();
	}

	public getPeriodDetails(clientId: any, periodName: any){
		const url = environment.host +'/participant/'+clientId+'/commission/'+periodName;
		return this.http.get(url.toString()).toPromise();
	}

	public saveVolumeTransferDetails(payload: any) {
		return this.http.post(this.volTransferPlanUrl.toString(), payload).toPromise();
	}

	public getVolumeTransferMetaData() {
		return this.http.get(this.volTransferUrl.toString() + '/metadata').toPromise();
	}
}